import React from 'react';
import { Platform } from 'react-native';
import WebWelcomeScreen from './WebWelcomeScreen';
import NativeWelcomeScreen from './NativeWelcomeScreen';

export type WelcomeScreenOwnProps = {};

export type WelcomeScreenProps = WelcomeScreenOwnProps;

const WelcomeScreen: React.FC<WelcomeScreenProps> = (_props) => {
    return Platform.OS === 'web' ? <WebWelcomeScreen /> : <NativeWelcomeScreen />;
};

export default React.memo(WelcomeScreen);
